import { createRouter } from "@tanstack/react-router";
import { setupRouterSsrQueryIntegration } from "@tanstack/react-router-ssr-query";

import "./lib/polyfill";
import { createQueryClient } from "./components/query-provider";
import { deLocalizeUrl, localizeUrl } from "./paraglide/runtime";
// Import the generated route tree
import { routeTree } from "./routeTree.gen";

export interface RouterContext {
	queryClient: ReturnType<typeof createQueryClient>;
}

// Create a new router instance
export const getRouter = () => {
	const queryClient = createQueryClient();
	const router = createRouter({
		context: {
			queryClient,
		},
		routeTree,
		scrollRestoration: true,
		defaultPreloadStaleTime: 0,
		rewrite: {
			input: ({ url }) => deLocalizeUrl(url),
			output: ({ url }) => localizeUrl(url),
		},
	});

	setupRouterSsrQueryIntegration({
		router,
		queryClient,
	});

	return router;
};

// Register the router instance for type safety
declare module "@tanstack/react-router" {
	interface Register {
		router: ReturnType<typeof getRouter>;
	}
}
